export function setAppHeight() {
  const doc = document.documentElement;
  // Calculates the actual viewport height dynamically and sets a CSS variable
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
}
